import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const HavadesEnferadiPaths: IPaths = {
  BimehNameh: {
    List: '/HavadesEnferadi/List',
    Estelam: '/HavadesEnferadi/Estelam',
    Detail: '/HavadesEnferadi/Detail',
    Sodoor: '/HavadesEnferadi/Sodoor',
    ElhaghiyehSaderehDetail: '/HavadesEnferadi/ElhaghiyehSaderehDetail',
    ElhaghiyehHayeSadereh: '/HavadesEnferadi/ElhaghiyehHayeSadereh',
  },
  Estelam: {
    TarhProducts: '/HavadesEnferadi/TarhProducts',
  },
};
